module.exports = __webpack_public_path__ + "static/media/e-bill.91dab2fc.svg";